<template>
  <div class="field">
    <label
      v-if="label"
      class="label"
      :for="inputId"
    >{{ label }}</label>
    <div class="control">
      <div class="select">
        <select
          :id="inputId"
          v-model="fieldValue"
          :class="{ 'is-danger': hasError }"
        >
          <option
            v-for="option in parsedOptions"
            :value="optionValue === 'object' ? (option as { id: number }).id : option[optionValue]"
            :key="optionValue === 'object' ? (option as { id: number }).id : option[optionValue]"
          >
            {{ option[optionName] }}
          </option>
        </select>
      </div>
      <button
        v-if="canEmpty && fieldValue"
        type="button"
        @click="fieldValue = null"
        style="margin: 0.5rem 0 0 0.5rem"
        class="delete"
      ></button>
    </div>
    <p
      class="help is-danger"
      v-if="error"
    >{{ error[0] }}</p>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from "vue"

/** Select input */
export default defineComponent({
  props: {
    /** The input value */
    modelValue: [String, Number, Object, null],
    /** Label for the field */
    label: String,
    /** Array of objects for the select options */
    options: {
      type: Array as PropType<Array<any>>,
      required: true
    },
    /** Property name of the value to use for each option
     * When set to 'object' it uses the id property while setting the
     * entire option object as the modelValue
     */
    optionValue: {
      type: String,
      default: "value"
    },
    /** Property name of the label for the options */
    optionName: {
      type: String,
      default: "name"
    },
    /** Array of error messages */
    error: Array as PropType<Array<string>>,
    /** ID assigned to the input if present, otherwise uses the label */
    htmlId: String,
    /** Show a cross that deselects the current value by setting to null */
    canEmpty: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    parsedOptions() {
      if (typeof this.options[0] === 'string') {
        return this.options.map(option => ({ value: option, name: option }))
      }
      return this.options
    },
    hasError() {
      return this.error !== undefined
    },
    fieldValue: {
      get() {
        if (this.optionValue === 'object' && this.modelValue !== null) {
          return (this.modelValue as { id: number }).id
        }
        return this.modelValue
      },
      set(fieldValue: any) {
        if (this.optionValue === 'object') {
          this.$emit("update:modelValue", this.options.find(option => option.id === fieldValue))
        } else {
          this.$emit("update:modelValue", fieldValue)
        }
      }
    },
    inputId() {
      if (this.htmlId === undefined) {
        if (this.label === undefined) {
          return undefined
        }
        return this.label.replaceAll(" ", "-").toLowerCase()
      } else {
        return this.htmlId
      }
    }
  }
})
</script>
